import { Login_login } from "@shared/graphql/types/Login";

const userHasPermission = (user: Login_login, permission: string): boolean =>
  user.all_permissions.includes(permission);

export default userHasPermission;
